<form action="javascript:void(0)">
    <div #divclick *ngIf="localText!=undefined">
        <a role="button" class="btn btn-link pl-0" style="color: #337ab7;" (click)="setLocales()" >
            {{localText}}
        </a>
      
    </div>

</form>
